<template>
  <Preloader v-if="localLoading" />
  <div class="order-plan-wrap" v-else>
    <template v-once>
      <FirstPayment :id="id" v-if="needFirstPayment || isExpired === true || account.trialEnabled" />
      <PlanRenewOnDefault :plan="plan" v-else-if="isExpired === true && !plan.price" />
      <PlanDowngrade :plan="plan" v-else-if="!isUpgrade && isExpired === false" />
      <PlanUpgrade v-else-if="isExpired === false" :id="id" />
    </template>
  </div>
</template>
<script>
import usePayment from '@/compositions/accounting/usePayment';
import { paymentDrivers } from '@/enums';
import FirstPayment from '@/components/Payment/Payment/FirstPayment';
import PlanUpgrade from '@/components/Payment/Plans/PlanUpgrade';
import useAccount from '@/compositions/accounting/useAccount';
import { computed } from '@vue/composition-api';
import usePlan from '@/compositions/accounting/usePlan';
import useValidation from '@/compositions/useValidation';
import PlanDowngrade from '@/components/Payment/Plans/PlanDowngrade';
import Preloader from '@/components/Preloader';
import useSubscription from '@/compositions/accounting/useSubscription';
import PlanRenewOnDefault from '@/components/Payment/Plans/PlanRenewOnDefault';

export default {
  name: 'OrderPlan',
  components: {
    PlanRenewOnDefault,
    Preloader,
    PlanDowngrade,
    PlanUpgrade,
    FirstPayment,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup({ id }) {
    const { account, nextPlanText, expirationText } = useAccount();
    const { getPlanById, fetchAll } = usePlan();
    const { withLoading, localLoading } = useValidation();
    const {
      paymentDialog, setDriver,
    } = usePayment();

    const { isExpired } = useSubscription();

    const isSame = computed(() => account.value.plan.id === id);
    const isNextSame = computed(() => account.value.nextPlan?.id === id);
    const plan = computed(() => getPlanById(id));

    withLoading(async () => {
      await fetchAll();
    });

    const isUpgrade = computed(() => {
      return !account.value.planPrice
        || (account.value.planPrice?.value < plan.value.price?.value);
    });

    setDriver(account.value.driver);

    const needFirstPayment = computed(() => {
      return account.value.plan.default || isExpired.value;
    });

    return {
      account,
      paymentDialog,
      paymentDrivers,
      needFirstPayment,
      isSame,
      isNextSame,
      isUpgrade,
      localLoading,
      plan,
      nextPlanText,
      expirationText,
      isExpired,
    };
  },
};
</script>

<style lang="scss" scoped>
.order-plan-wrap {
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.16);
  border-radius: 0.625rem;
  margin-top: 1rem;
}

</style>
